<template>
  <div v-if="show" class="ta-company-select-wrapper">
    <slot :onChange="onChange" :agencyOptions="agencyOptions" :companyId="companyId">
      <b-form-group
        :description="hintText"
        :label="label"
        label-for="company-select">
        <b-form-select id="company-select"
                       v-model="companyId"
                       :options="agencyOptions"
                       trim
                       @change="onChange"
                       :disabled="disabled"></b-form-select>
      </b-form-group>
    </slot>
  </div>
</template>
<script>
import {mapActions, mapState, mapMutations} from "vuex";
import i18n from "@/i18n";

export default {
  name: "CompanySelect",
  props: {
    label: {
      type: String,
      default: () => i18n.t('Switch Agency')
    },
    hintText: {
      type: String,
      default: () => i18n.t('Select agency you are bidding on behalf of')
    },
    confirmationQuestion: {
      type: String,
      default: () => i18n.t('You are changing agency you are bidding with for this lot.')
    },
    confirmationTitle: {
      type: String,
      default: () => i18n.t('Please Confirm')
    },
    confirmationOkText: {
      type: String,
      default: () => i18n.t('Proceed')
    },
    confirmationCancelText: {
      type: String,
      default: () => i18n.t('Cancel')
    },
    successNotificationTitle: {
      type: String,
      default: () => i18n.t('Agency updated')
    },
    successNotificationText: {
      type: String,
      default: () => i18n.t('Your agency has been updated.')
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      lot: state => state.lotObject.data,
      auction: state => state.auctionObject.data,
      customer: state => state.customer,
    }),
    show() {
      return this.lot?.auction?.bidder_company_id && this.customer && Object.keys(this.customer?.companies || {}).length
    },
    bidder_company_id() {
      return this.auction.bidder_company_id
    },
    agencyOptions() {
      const agencies = [];
      for (let k in this.customer.companies) {
        agencies.push({
          'value': k,
          'text': this.customer.companies[k] + ' (' + k + ')'
        });
      }
      return agencies;
    }
  },
  data: () => ({
    companyId: null
  }),
  watch: {
    bidder_company_id: {
      handler() {
        this.companyId = this.bidder_company_id;
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['updateCompanyId']),
    ...mapMutations(['showNotification', 'showModalMsgBox']),
    async onChange(value) {
      if (value !== undefined) {
        this.companyId = value;
      }
      const result = await this.$confirm(`${this.confirmationQuestion}`, null, null, null,
        this.confirmationTitle, this.confirmationOkText, this.confirmationCancelText
      )
      if (!result) {
        this.companyId = this.bidder_company_id;
        return;
      }
      const {success, error} = await this.updateCompanyId({
        auction_uuid: this.lot.auction.uuid,
        company_id: this.companyId
      })
      if (success) {
        this.showNotification({
          title: this.successNotificationTitle,
          text: this.successNotificationText,
          variant: 'success',
          duration: 5000
        });
      } else {
        this.showModalMsgBox({
          title: this.$t('Error'),
          content: this.$t(error || 'Error when updating agency.')
        });
        this.companyId = this.bidder_company_id;
      }
    }
  },
}
</script>

<style scoped>

</style>
